<template>
  <translate tag="p" class="section-title"> Extras </translate>
  <table class="costs-table">
    <tbody>
      <tr v-for="(extra, index) of extras" :key="index">
        <td>{{ extra.name }}</td>
        <td>
          <template v-if="extra.quantity > 1">{{ extra.quantity }}</template>
        </td>
        <td>
          <pu-price
            v-if="extra.price"
            :price="calculateExtraTotalPrice(extra)"
            :display-original-price="true"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Currency } from 'dinero.js'
import { Money, MoneyType, SimpleMoney } from '~/utility/money'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

interface Extra {
  name: string
  price: SimpleMoney
  quantity: number
}

@Component
class BookingExtras extends Vue {
  @Prop()
  extras: Extra[]

  calculateExtraTotalPrice(extra: Extra): MoneyType {
    const basePrice = Money({
      amount: extra.price.amountMinor,
      currency: extra.price.currency as Currency,
    })
    return basePrice.multiply(extra.quantity)
  }
}

export default toNative(BookingExtras)
</script>
